<template>
  <div class="container">
    <app-more
      title="视频专区"
      more="更多视频"
      :link="{ path: '/video' }"
    ></app-more>
    <div class="video-box">
      <div class="box" v-for="(s, i) of datas" :key="i">
        <a @click="$router.push({name:'vdetail',params:{id:s.id}})" class="link">
          <div class="play"></div>
          <img :src="s.img" class="" />
        </a>
        <h3>{{ s.title }}</h3>
        <p>{{ s.description }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import more from "../public/more.vue";
export default {
  components: {
    "app-more": more
  },
  data() {
    return {
      datas: [],
      get: {
        pi: 1,
        ps: 4,
        name: "vedio"
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http.get("/Index/index/lists", { params: this.get }).then(res => {
        this.datas = res.datas;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.video-box {
  img {
    max-width: 100%;
  }
  border-bottom: 2px dotted #dcdcdc;
  display: flex;
  .box {
    margin: 0 6px;
    h3 {
      font-size: 20px;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      opacity: 1;
      margin: 13px 0 6px;
    }
    p {
      font-size: 18px;
      font-weight: 300;
      line-height: 26px;
      color: rgba(0, 0, 0, 1);
      opacity: 1;
      height: 112px;
    }
    .link {
      position: relative;
      display: block;
      .play {
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url("../../assets/img/play.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 20%;
      }
    }
    &:first-child {
      margin-left: 0 !important;
    }
    &:last-child {
      margin-right: 0 !important;
    }
  }
}

@media (max-width: 768px) {
  .video-box {
    flex-wrap: wrap;
    .box {
      width: 50%;
      margin: 0 0 10px;
      h3 {
        font-size: 16px !important;
      }
      p {
        font-size: 12px;
        margin-top: 20px;
        font-weight: 300;
        line-height: 18px;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
        height: auto;
      }
      &:nth-child(2n) {
        padding-left: 5px;
      }
      &:nth-child(2n + 1) {
        padding-right: 5px;
      }
    }
  }
}
</style>